/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_DescriptionInputs */

const fr_auth_forgot_description = /** @type {(inputs: Auth_Forgot_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez votre adresse email : nous vous enverrons un lien pour choisir un nouveau mot de passe.`)
};

const en_auth_forgot_description = /** @type {(inputs: Auth_Forgot_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email address and we will send you a link to choose a new password.`)
};

/**
* | output |
* | --- |
* | "Enter your email address and we will send you a link to choose a new password." |
*
* @param {Auth_Forgot_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_description = /** @type {((inputs?: Auth_Forgot_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_forgot_description(inputs)
	return fr_auth_forgot_description(inputs)
});